module.exports = __webpack_public_path__ + "img/40544ac.jpg";